// extracted by mini-css-extract-plugin
export default {"frame":"style_frame__ltPbQ","title":"style_title__75Utz","text":"style_text__39PUz","button":"style_button__JvC+b"};